export default __webpack_public_path__ + "static/media/report-inspection-score-month.0cfbdbf7.svg";